import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Cluster} from '../../services/api/clusters/cluster.model';
import {ClusterRegion} from '../../services/api/vocabulary/cluster/regions/cluster.region.vocabulary.model';
import {UUID} from '../../shared/types/uuid.type';

/**
 * State interface for clusters
 * Uses EntityState for normalized data storage with efficient lookups
 */
export interface ClustersState extends EntityState<Cluster> {
  // Entity adapter provides: ids, entities

  // Loading states
  loading: boolean;
  loadingById: { [id: string]: boolean };
  creating: boolean;
  updating: { [id: string]: boolean };
  deleting: { [id: string]: boolean };

  // Error states
  error: any | null;
  createError: any | null;
  updateError: { [id: string]: any | null };
  deleteError: { [id: string]: any | null };

  // Metadata
  loaded: boolean;
  lastUpdated: number | null;
  selectedClusterId: string | null;

  // Regions (supporting data)
  regions: ClusterRegion[] | null;
  regionsLoading: boolean;
  regionsLoaded: boolean;
  regionsError: any | null;
}

/**
 * Entity adapter for efficient CRUD operations
 */
export const clustersAdapter: EntityAdapter<Cluster> =
  createEntityAdapter<Cluster>({
    selectId: (cluster: Cluster): UUID => cluster.id,
    sortComparer: (a: Cluster, b: Cluster): 1 | -1 => (a.createdAt < b.createdAt ? 1 : -1)
  });

/**
 * Initial state for clusters
 */
export const initialClustersState: ClustersState =
  clustersAdapter.getInitialState({
    loading: false,
    loadingById: {},
    creating: false,
    updating: {},
    deleting: {},
    error: null,
    createError: null,
    updateError: {},
    deleteError: {},
    loaded: false,
    lastUpdated: null,
    selectedClusterId: null,

    regions: null,
    regionsLoading: false,
    regionsLoaded: false,
    regionsError: null
  });
